import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Post Category ", -1)
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled hidden>Select a category...</option><option value=\"looking_to_borrow\">Help Wanted / Looking to Borrow</option><option value=\"for_sale\">For Sale</option><option value=\"free\">Free / Donate</option><option value=\"service_to_offer\">Service to Offer</option><option value=\"question\">Question</option><option value=\"social\">Social / Announcement</option><option value=\"general\">General</option>", 8)
const _hoisted_10 = [
  _hoisted_2
]

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  emits: ["choice_made"],
  setup(__props, { emit }) {

const choice = ref("");


const handleChoice = () => {
  emit("choice_made", choice.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      class: "w-full p-3 text-sm border border-primary-200 rounded-lg bg-white focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
      onChange: handleChoice,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((choice).value = $event))
    }, _hoisted_10, 544), [
      [_vModelSelect, choice.value]
    ])
  ]))
}
}

})